import { useId } from 'react'

/**
 * A box with its name and, beside it, one line saying what it allows. The line is the box's
 * description rather than part of its name, so a screen reader says the name first and the
 * explanation after, instead of one long label.
 */
export function SettingBox({
  label,
  help,
  checked,
  disabled,
  busy,
  onChange,
}: {
  label: string
  help: string
  checked: boolean
  disabled?: boolean
  /** Saving: said to assistive technology, without disabling the box (which would drop its focus). */
  busy?: boolean
  onChange: (checked: boolean) => void
}) {
  const id = useId()
  return (
    <div className="checkbox checkbox--described">
      <input
        id={id}
        type="checkbox"
        checked={checked}
        disabled={disabled}
        aria-busy={busy || undefined}
        aria-describedby={`${id}-help`}
        onChange={(event) => {
          // Read now, not later: React may run later work after `currentTarget` is gone (#105).
          onChange(event.currentTarget.checked)
        }}
      />
      <span className="checkbox__text">
        <label className="checkbox__label" htmlFor={id}>
          {label}
        </label>
        <span className="small muted" id={`${id}-help`}>
          {help}
        </span>
      </span>
    </div>
  )
}
